import fetch from 'isomorphic-fetch';
import Config from '../config';
import { setPageTotal } from './page';

export const REQUEST_POSTS = 'REQUEST_POSTS';
export function requestPosts(filters){
	return { type: REQUEST_POSTS, filters }
}

export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export function receivePosts(content){
	return function(dispatch, getState){
		dispatch({ type: RECEIVE_POSTS, content	});
	}
}

export const SET_STATIC_HTML = 'SET_STATIC_HTML';
export function setStaticHtml(html){
	return { type: SET_STATIC_HTML, html };
}

export const SET_FEATURED_RESOURCE = 'SET_FEATURED_RESOURCE';
export function setFeaturedResource(html){
	return { type: SET_FEATURED_RESOURCE, html };
}

export function fetchPosts(){
	return function(dispatch, getState){
		dispatch(requestPosts());

		return fetch(Config.getAPIEndpoint(getState()))
			.then(response => {
				dispatch(setPageTotal(response.headers.get('X-WP-TotalPages')));
				return response.json();
			})
			.then(json => {
				return dispatch(receivePosts(json));
			})
	}
}



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/actions/posts.js